import { ReactNode, useEffect } from 'react';

interface BodyTagClassListProps {
  children: ReactNode;
  className: string;
}

const defaultProps = {
  children: null,
  className: '',
};

function BodyTagClassList({ className, children }: BodyTagClassListProps) {
  useEffect(() => {
    if (className) {
      document.body.classList.add(className);
    }
    return () => {
      document.body.classList.remove(className);
    };
  }, [className]);

  return <>{children}</>;
}

BodyTagClassList.defaultProps = defaultProps;

export default BodyTagClassList;
